export const USERS_STATUS_ENABLED = true
export const USERS_STATUS_DELETED = false

export const USERS_STATUS_LIST = [
  {
    value: USERS_STATUS_ENABLED,
    slug: USERS_STATUS_ENABLED,
    label: 'Actif',
    color: 'green'
  },
  {
    value: USERS_STATUS_DELETED,
    slug: USERS_STATUS_DELETED,
    label: 'Inactif',
    color: 'red'
  }
]
